import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute } from '../../constants';

function setupOsGenerated(): void {
  applicationModuleRegistry.register({
    closeable: true,
    entry: 'kpi-generated',
    id: 'kpi-generated',
    name: 'kpi-generated.title',
    route: ApplicationRoute.OS_GENERATED,
  });
}

export {
  setupOsGenerated,
};
